import {
  Grid,
  Paper,
  Typography,
  Button,
  withStyles,
  MenuItem,
} from "@material-ui/core";
// Lib
import moment from "moment";
import "moment/locale/vi";
import classNames from "classnames";
import React from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
// Component
import BusinessReportTemplate from "./reviewReport/businessReportTemplate";
import OneEmployeeReportTemplate from "./reviewReport/oneEmployeeReportTemplate";
import EmployeeReportTemplate from "./reviewReport/employeeReportTemplate";
import ReviewReport from "./reviewReport";
import "../../css/reportPage.css";
import Loading from "../loading";
import Snackbar from "../snackbar";
import Header from "../../partials/header";
import InputFormat from "../../partials/inputForm";
import { parseCountry } from "../../utils/setting";
import { styles } from "./styles";
import MomentUtils from "@date-io/moment";
import { MuiPickersUtilsProvider, DatePicker } from "@material-ui/pickers";
class Report extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      datetimeBusiness: moment().valueOf(),
      datetimeOneEmployee: moment().valueOf(),
      datetimeEmployee: moment().valueOf(),
      openReview: false,
      typeReport: "",
    };
  }
  async componentDidMount() {
    let checkListEmployee = await this.props.getListEmployeeService();
    if (checkListEmployee.code !== 1)
      this.mSnackbar.handleClick(checkListEmployee.message, "error");
  }
  getData = async (typeReport) => {
    const {
      datetimeBusiness,
      datetimeOneEmployee,
      datetimeEmployee,
      employeeCode,
    } = this.state;
    this.loading.startLoading();
    if (typeReport == "business") {
      let data = {
        from: moment(datetimeBusiness).startOf("month").valueOf(),
        to: moment(datetimeBusiness).endOf("month").valueOf(),
      };
      let checkServiceCost = await this.props.getServiceCost([data.from]);
      if (checkServiceCost.code !== 1)
        this.mSnackbar.handleClick(checkServiceCost.message, "error");
      let checkListBookings = await this.props.getListBookings(data);
      if (checkListBookings.code !== 1)
        this.mSnackbar.handleClick(checkListBookings.message, "error");
      let checkListOrders = await this.props.getListOrders(data);
      if (checkListOrders.code !== 1)
        this.mSnackbar.handleClick(checkListOrders.message, "error");
    } else if (typeReport == "employee") {
      let data = {
        from: moment(datetimeOneEmployee).startOf("month").valueOf(),
        to: moment(datetimeOneEmployee).endOf("month").valueOf(),
      };
      let checkListOrders = await this.props.getListOrders(data);
      if (checkListOrders.code !== 1)
        this.mSnackbar.handleClick(checkListOrders.message, "error");
    } else if (typeReport == "oneEmployee") {
      let data = {
        from: moment(datetimeEmployee).startOf("month").valueOf(),
        to: moment(datetimeEmployee).endOf("month").valueOf(),
      };
      let checkListOrders = await this.props.getListOrders(data);
      if (checkListOrders.code !== 1)
        this.mSnackbar.handleClick(checkListOrders.message, "error");
      let checkInfoEmployee = await this.props.getInfoForReport({
        userCode: employeeCode,
      });
      if (checkInfoEmployee.code !== 1)
        this.mSnackbar.handleClick(checkInfoEmployee.message, "error");
      let checkEmployeeBonus = await this.props.getEmployeeBonus({
        employeeCode: employeeCode,
        from: data.from,
        to: data.to,
      });
      if (checkEmployeeBonus.code !== 1)
        this.mSnackbar.handleClick(checkEmployeeBonus.message, "error");
    }
    this.loading.stopLoading();
  };
  createPdf = async (typeReport) => {
    const {
      datetimeBusiness,
      datetimeOneEmployee,
      datetimeEmployee,
    } = this.state;
    let { t, setting, service } = this.props;
    await this.getData(typeReport);
    if (typeReport == "business") {
      let data = {
        listBookings: this.props.listBookings,
        totalBooking: this.props.totalBooking,
        listOrders: this.props.listOrders,
        totalOrder: this.props.totalOrder,
        from: moment(datetimeBusiness).startOf("month").valueOf(),
        to: moment(datetimeBusiness).endOf("month").valueOf(),
        setting: setting,
        service: service,
        serviceCost: this.props.serviceCost,
        t: t,
      };
      let businessReport = BusinessReportTemplate(data);
      pdfMake.createPdf(businessReport).open({}, window);
    } else if (typeReport == "employee") {
      let data = {
        listOrders: this.props.listOrders,
        totalOrder: this.props.totalOrder,
        from: moment(datetimeEmployee).startOf("month").valueOf(),
        to: moment(datetimeEmployee).endOf("month").valueOf(),
        datetime: moment(datetimeEmployee),
        listEmployee: this.props.listEmployee,
        t: t,
      };
      let emplopyeeReport = EmployeeReportTemplate(data);
      pdfMake.createPdf(emplopyeeReport).open({}, window);
    } else if (typeReport == "oneEmployee") {
      let data = {
        listOrders: this.props.listOrders,
        totalOrder: this.props.totalOrder,
        from: moment(datetimeOneEmployee).startOf("month").valueOf(),
        to: moment(datetimeOneEmployee).endOf("month").valueOf(),
        setting: setting,
        oneEmployee: this.props.oneEmployee,
        bonusEmployee: this.props.bonusEmployee,
        t: t,
      };
      let oneEmployeeReport = OneEmployeeReportTemplate(data);
      pdfMake.createPdf(oneEmployeeReport).open({}, window);
    }
  };
  getValueSelect = () => {
    let year = new Date().getFullYear();
    let startMonth = new Date().getMonth() + 1;
    let arr = [];

    for (let i = startMonth; i >= 1; i--) {
      arr.push(`${year}${i}`);
    }
    year -= 1;
    for (let i = 12; i >= 1; i--) {
      arr.push(`${year}${i}`);
    }
    return arr;
  };
  handleDialogEditClose = () => {
    this.setState({ openReview: false });
  };
  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };
  openReviewReport = async (typeReport) => {
    const { t } = this.props;
    const {
      datetimeBusiness,
      datetimeOneEmployee,
      datetimeEmployee,
      employeeCode,
    } = this.state;
    if (typeReport == "business") {
      this.setState({ typeReport: typeReport, openReview: true });
      let data = {
        from: moment(datetimeBusiness).startOf("month").valueOf(),
        to: moment(datetimeBusiness).endOf("month").valueOf(),
      };
      let checkServiceCost = await this.props.getServiceCost([data.from]);
      if (checkServiceCost.code !== 1)
        this.mSnackbar.handleClick(checkServiceCost.message, "error");
      let checkListBookings = await this.props.getListBookings(data);
      if (checkListBookings.code !== 1)
        this.mSnackbar.handleClick(checkListBookings.message, "error");
      let checkListOrders = await this.props.getListOrders(data);
      if (checkListOrders.code !== 1)
        this.mSnackbar.handleClick(checkListOrders.message, "error");
    } else if (typeReport == "employee") {
      this.setState({ typeReport: typeReport, openReview: true });
      let data = {
        from: moment(datetimeEmployee).startOf("month").valueOf(),
        to: moment(datetimeEmployee).endOf("month").valueOf(),
      };
      let checkListOrders = await this.props.getListOrders(data);
      if (checkListOrders.code !== 1)
        this.mSnackbar.handleClick(checkListOrders.message, "error");
    } else if (typeReport == "oneEmployee") {
      if (employeeCode) {
        this.setState({ typeReport: typeReport, openReview: true });
        let data = {
          from: moment(datetimeOneEmployee).startOf("month").valueOf(),
          to: moment(datetimeOneEmployee).endOf("month").valueOf(),
        };
        let checkListOrders = await this.props.getListOrders(data);
        if (checkListOrders.code !== 1)
          this.mSnackbar.handleClick(checkListOrders.message, "error");
        let checkInfoEmployee = await this.props.getInfoForReport({
          userCode: employeeCode,
        });
        if (checkInfoEmployee.code !== 1)
          this.mSnackbar.handleClick(checkInfoEmployee.message, "error");
        let checkEmployeeBonus = await this.props.getEmployeeBonus({
          employeeCode: employeeCode,
          from: data.from,
          to: data.to,
        });
        if (checkEmployeeBonus.code !== 1)
          this.mSnackbar.handleClick(checkEmployeeBonus.message, "error");
      } else {
        this.mSnackbar.handleClick(t("report_please_select_employee"), "error");
      }
    }
  };
  render() {
    const { classes, t, i18n } = this.props;
    const {
      datetimeBusiness,
      datetimeEmployee,
      datetimeOneEmployee,
      openReview,
      typeReport,
      employeeCode,
    } = this.state;
    const lng = parseCountry(i18n.language);
    moment.locale(lng);
    return (
      <div>
        <ReviewReport
          handleDialogEditClose={this.handleDialogEditClose}
          openReview={openReview}
          datetimeBusiness={datetimeBusiness}
          datetimeEmployee={datetimeEmployee}
          datetimeOneEmployee={datetimeOneEmployee}
          typeReport={typeReport}
          onRef={(modal) => (this.mModalReport = modal)}
          employeeCode={employeeCode}
        />
        <Loading onRef={(load) => (this.loading = load)} />
        <Snackbar
          color="white"
          onRef={(snackbar) => (this.mSnackbar = snackbar)}
        />
        <Header session={t("sidebar_manage")} title={t("report_report_spa")} />
        <Grid container spacing={3}>
          <Grid item xs={12} sm={12} md={6}>
            <Paper className={classes.root}>
              <Grid
                container
                spacing={3}
                justify="center"
                alignItems="flex-end"
              >
                <Grid
                  item
                  xs={8}
                  sm={8}
                  md={8}
                  container
                  direction="column"
                  spacing={3}
                >
                  <Grid item xs={12}>
                    <Typography
                      className={classNames(classes.label, classes.textLeft)}
                    >
                      {t("report_business_sumary_report")}
                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <MuiPickersUtilsProvider
                      libInstance={moment}
                      utils={MomentUtils}
                      locale={i18n.language}
                    >
                      <DatePicker
                        label={t("report_date_time")}
                        inputVariant="outlined"
                        openTo="month"
                        views={["year", "month"]}
                        value={new Date(datetimeBusiness)}
                        onChange={(value) =>
                          this.handleChange({
                            target: { value: value, name: "datetimeBusiness" },
                          })
                        }
                        cancelLabel={t("date_picker_cancel")}
                        okLabel={t("date_picker_ok")}
                      />
                    </MuiPickersUtilsProvider>
                  </Grid>
                </Grid>
                <Grid
                  item
                  xs={4}
                  sm={4}
                  md={4}
                  className={classNames(classes.wrapButton)}
                >
                  <Button
                    variant="contained"
                    component="span"
                    color="primary"
                    className={classNames(classes.button, classes.btnBlue)}
                    onClick={() => this.openReviewReport("business")}
                  >
                    {t("report_review")}
                  </Button>
                  <Button
                    variant="contained"
                    component="span"
                    color="secondary"
                    className={classNames(classes.button, classes.btnRed)}
                    onClick={() => this.createPdf("business")}
                  >
                    {t("report_print")}
                  </Button>
                </Grid>
              </Grid>
            </Paper>
          </Grid>
          <Grid item xs={12} sm={12} md={6}>
            <Paper className={classes.root}>
              <Grid
                container
                spacing={3}
                justify="center"
                alignItems="flex-end"
              >
                <Grid
                  item
                  xs={8}
                  sm={8}
                  md={8}
                  container
                  direction="column"
                  spacing={3}
                >
                  <Grid item xs={12}>
                    <Typography
                      className={classNames(classes.label, classes.textLeft)}
                    >
                      {t("report_employee_utilization_report")}
                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <MuiPickersUtilsProvider
                      libInstance={moment}
                      utils={MomentUtils}
                      locale={i18n.language}
                    >
                      <DatePicker
                        label={t("report_date_time")}
                        inputVariant="outlined"
                        openTo="month"
                        views={["year", "month"]}
                        value={new Date(datetimeEmployee)}
                        onChange={(value) =>
                          this.handleChange({
                            target: { value: value, name: "datetimeEmployee" },
                          })
                        }
                        cancelLabel={t("date_picker_cancel")}
                        okLabel={t("date_picker_ok")}
                      />
                    </MuiPickersUtilsProvider>
                  </Grid>
                </Grid>
                <Grid
                  item
                  xs={4}
                  sm={4}
                  md={4}
                  className={classNames(classes.wrapButton)}
                >
                  <Button
                    variant="contained"
                    component="span"
                    color="primary"
                    className={classNames(classes.button, classes.btnBlue)}
                    onClick={() => this.openReviewReport("employee")}
                  >
                    {t("report_review")}
                  </Button>
                  <Button
                    variant="contained"
                    component="span"
                    color="secondary"
                    className={classNames(classes.button, classes.btnRed)}
                    onClick={() => this.createPdf("employee")}
                  >
                    {t("report_print")}
                  </Button>
                </Grid>
              </Grid>
            </Paper>
          </Grid>
          <Grid item xs={12} sm={12} md={6}>
            <Paper className={classes.root}>
              <Grid
                container
                spacing={3}
                justify="center"
                alignItems="flex-end"
              >
                <Grid
                  item
                  xs={8}
                  sm={8}
                  md={8}
                  container
                  direction="column"
                  spacing={3}
                >
                  <Grid item xs={12}>
                    <Typography
                      className={classNames(classes.label, classes.textLeft)}
                    >
                      {t("report_employee_report")}
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    container
                    spacing={3}
                    justify="center"
                    alignItems="center"
                  >
                    <Grid
                      item
                      xs={12}
                      md={6}
                      className={classNames(classes.wrapButton)}
                    >
                      <InputFormat
                        select
                        // required
                        label={t("report_employee_name")}
                        name="employeeCode"
                        fullWidth
                        value={employeeCode}
                        onChange={this.handleChange}
                      >
                        {this.props.listEmployee.map((employee, index) => {
                          return (
                            <MenuItem key={index} value={employee.userCode}>
                              {employee.name}
                            </MenuItem>
                          );
                        })}
                      </InputFormat>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      md={6}
                      className={classNames(classes.wrapButton)}
                    >
                      <MuiPickersUtilsProvider
                        libInstance={moment}
                        utils={MomentUtils}
                        locale={i18n.language}
                      >
                        <DatePicker
                          label={t("report_date_time")}
                          inputVariant="outlined"
                          openTo="month"
                          views={["year", "month"]}
                          value={new Date(datetimeOneEmployee)}
                          onChange={(value) =>
                            this.handleChange({
                              target: {
                                value: value,
                                name: "datetimeOneEmployee",
                              },
                            })
                          }
                          cancelLabel={t("date_picker_cancel")}
                          okLabel={t("date_picker_ok")}
                        />
                      </MuiPickersUtilsProvider>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid
                  item
                  xs={4}
                  sm={4}
                  md={4}
                  className={classNames(classes.wrapButton)}
                >
                  <Button
                    variant="contained"
                    component="span"
                    color="primary"
                    className={classNames(classes.button, classes.btnBlue)}
                    onClick={() => this.openReviewReport("oneEmployee")}
                  >
                    {t("report_review")}
                  </Button>
                  <Button
                    variant="contained"
                    component="span"
                    color="secondary"
                    className={classNames(classes.button, classes.btnRed)}
                    onClick={() => this.createPdf("oneEmployee")}
                  >
                    {t("report_print")}
                  </Button>
                </Grid>
              </Grid>
            </Paper>
          </Grid>
        </Grid>
      </div>
    );
  }
}
const mapState = (state) => ({
  listBookings: state.report.listBookings,
  totalBooking: state.report.totalBooking,
  listOrders: state.report.listOrders,
  totalOrder: state.report.totalOrder,
  setting: state.setting.setting,
  service: state.service.service,
  serviceCost: state.serviceCost.serviceCost,
  listEmployee: state.employees.employee,
  oneEmployee: state.employees.oneEmployee,
  bonusEmployee: state.employees.bonusEmployee,
});

const mapDispatch = (dispatch) => ({
  getListBookings: dispatch.report.getBookingReportSpa,
  getListOrders: dispatch.report.getListOrdersReportSpa,
  getListEmployeeSalary: dispatch.employees.getListEmployeeSalary,
  getServiceCost: dispatch.serviceCost.getServiceCost,
  getInfoForReport: dispatch.employees.getInfoForReport,
  getEmployeeBonus: dispatch.employees.getEmployeeBonus,
  getListEmployeeService: dispatch.employees.getListEmployeeService,
});

export default connect(
  mapState,
  mapDispatch
)(translate("translations")(withStyles(styles, { withTheme: true })(Report)));
